import { render } from "./AcconutView.vue?vue&type=template&id=22b8e910"
import script from "./AcconutView.vue?vue&type=script&lang=js"
export * from "./AcconutView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__